/* eslint-disable react/prop-types */
import React from 'react';
import { Button, Grid, HStack, Icon, Text } from '@chakra-ui/react';
import { BsFillSquareFill } from 'react-icons/bs';
import { useAppSelector } from 'hooks';
import { selectBasketStatuses } from 'store/consts';
import { Form } from 'components/Form';
import { updateStatus } from 'store/campaigns';
import { STATUS_UPDATE_SCHEMA } from './Campaign.schema';
import { ControlledSelect } from 'components/ControlledFormFields';
import Card from 'layouts/Card';
import { isUserBuyer } from 'store/user/user.selectors';
import { useTranslation } from 'react-i18next';

const CampaignStatusBadge = ({
  status,
  campaignId,
}: {
  status: string;
  campaignId: number;
}): JSX.Element => {
  const { t } = useTranslation();
  const STATUS = useAppSelector(selectBasketStatuses);
  const isBuyer = useAppSelector(isUserBuyer);
  const currentStatus = STATUS?.find(s => s.id === status);
  const editableStatuses = STATUS?.filter(s => s.isEditable) || [];
  const [isEditing, setIsEditing] = React.useState(false);

  return (
    <Card px={4} py={2} size='md' variant='outline'>
      <Grid
        gap={2}
        templateColumns='min-content 1fr'
        alignItems='center'
        fontSize='sm'
      >
        {!isEditing && (
          <Icon as={BsFillSquareFill} fill={currentStatus?.color} />
        )}
        {isEditing ? (
          <Form
            dispatchMethod={updateStatus}
            schema={STATUS_UPDATE_SCHEMA}
            defaultValues={{ status, campaignId }}
            onSubmit={() => setIsEditing(false)}
            onSubmitSuccess={() => setIsEditing(false)}
          >
            <HStack>
              <ControlledSelect
                name='status'
                options={editableStatuses.map(s => ({
                  id: s.id,
                  name: s.name,
                }))}
              />
              <Button size='sm' type='submit' variant='primary'>
                {t('confirm', 'Potwierdź')}
              </Button>
              <Button size='sm' onClick={() => setIsEditing(false)}>
                {t('cancel', 'Anuluj')}
              </Button>
            </HStack>
          </Form>
        ) : (
          /* eslint-disable indent */
          <HStack>
            <Text fontWeight='medium'>
              {currentStatus?.campaignNameVariant ||
                t('campaign.noStatus', 'Brak statusu')}
            </Text>
            {currentStatus?.isEditable && isBuyer && (
              <Button size='sm' onClick={() => setIsEditing(true)}>
                {t('change', 'Zmień')}
              </Button>
            )}
          </HStack>
        )}
      </Grid>
    </Card>
  );
};
CampaignStatusBadge.displayName = 'CampaignStatusBadge';
export { CampaignStatusBadge };
